// in src/jobs.js
import React from 'react';
import { useMediaQuery } from '@material-ui/core';
import { List, SimpleList, Datagrid, TextField, ReferenceField } from 'react-admin';
import { Edit, EditButton, SimpleForm, ReferenceInput, TextInput, SelectInput } from 'react-admin';
import { Show, ShowButton, SimpleShowLayout } from 'react-admin';
import { Create } from 'react-admin';
import { Filter } from 'react-admin';
import { ChipField, ReferenceManyField, SingleFieldList } from 'react-admin';


const JobFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <ReferenceInput label="Comp" source="compId" reference="comps" allowEmpty>
            <SelectInput optionText="name" />
        </ReferenceInput>
    </Filter>
);

export const JobList = props => {
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));

    return (
        <List filters={<JobFilter/>} {...props}>
            {(
                !!isSmall 
                ? (
                    <SimpleList
                        primaryText={record => `J${record.job}`}
                        secondaryText={record => new Date(record.date).toLocaleDateString()}
                        tertiaryText={record => `${record.status || 'pending'}`}
                    />
                )
                : (  
                    
                    <Datagrid rowClick="edit">
                        <TextField source="job" />
                        <ReferenceField source="invoice" reference="invoice">
                            <TextField source="invoice" />
                        </ReferenceField>
                        <TextField source="amount" />
                        <TextField source="date" />
                        <ShowButton />
                    </Datagrid>
                )
            )}
        </List>
    );
};

export const JobShow = ({job, ...props}) => {
//    const dataProvider = useDataProvider();
//    const [comp, setComp] = useState();
//    const [loading, setLoading] = useState(true);
//    const [error, setError] = useState();
//    useEffect(() => {
//        dataProvider.getManyByReference('job/component', { job })
//            .then(({ data }) => {
//                setComp(data);
//                setLoading(false);
//            })
//            .catch(error => {
//                setError(error);
//                setLoading(false);
//            })
//    }, []);
//
//    if (loading) return <Loading />;
//    if (error) return <Error />;
//    if (!comp) return null;

    return (
        <Show title={<JobTitle />}  {...props}>
            <SimpleShowLayout>
                <TextField source="job" />
                <TextField source="name" />
                <TextField source="amount" />
                {
                    //comp.map(item=><Typography>{item.name}</Typography>)
                }
                <ReferenceManyField label="Comments by" reference="job/component" target="job">
                    <SingleFieldList>
                        <ChipField source="name" />
                    </SingleFieldList>
                </ReferenceManyField>
            </SimpleShowLayout>
        </Show>
    )
};

export const JobEdit = props => (
    <Edit title={<JobTitle />}  {...props}>
        <SimpleForm>
            <TextInput disabled source="id" />
            <ReferenceInput source="compId" reference="comps">
                <SelectInput optionText="name" />
            </ReferenceInput>
            <TextInput source="title" />
            <TextInput multiline source="body" />
        </SimpleForm>
    </Edit>
);

export const JobCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <ReferenceInput source="compId" reference="comps">
                <SelectInput optionText="name" />
            </ReferenceInput>
            <TextInput source="title" />
            <TextInput multiline source="body" />
        </SimpleForm>
    </Create>
);

const JobTitle = ({ record }) => {
    return <span>Job {record ? `"${record.title}"` : ''}</span>;
};


// WEBPACK FOOTER //
// ./src/Job.js